import '../styles/eduhub-from-fa.scss';

import Snappy from '../libs/snappy/snappy';
import objectFitImages from 'object-fit-images';

objectFitImages(document.querySelectorAll('img:not(.lazyload)'));

import '../components/resizement/scripts/resize';
import '../.modernizrrc';

require('./bootstrapComponents');
require('./globalConfigs');
require('./pollyfills');
require('./picturefill');
require('./utilities/hbs-helpers');
require('../libs/validation/serverValidation');
require('../components/lazyimages/scripts/lazyimages');
require('../components/cfa-nav/scripts/cfa-nav');
require('../components/video/scripts/video');
require('../components/responsive-video/scripts/responsive-video');
require('../components/navigation/scripts/navigation');
require('../components/subNavigation/scripts/subNavigation');
require('../components/footer/scripts/footer');
require('../components/modal/scripts/modal');
require('../components/carousel/scripts/carousel');
require('../components/rowStrip/scripts/rowStrip');
require('../components/rowHeading/scripts/rowHeading');
require('../components/inputField/scripts/inputField');
require('../components/textarea/scripts/textarea');
require('../components/contentPromo/scripts/contentPromo');
require('../components/signpostContentPromo/scripts/signpostContentPromo');


require('../components/findCourse/scripts/findCourse');
require('../components/breadcrumbs/scripts/breadcrumbs');
require('../components/poll/scripts/poll');
require('../components/backToTop/scripts/backToTop');


require('../components/cookie/scripts/cookie');


require('../components/contactForm/scripts/contactForm');
require('../components/topbar/scripts/topbar');

require('../components/gallery/scripts/gallery');
require('../components/socialShare/scripts/socialShare');


require('../components/cw-footer/scripts/footer');

require('../components/accordion/scripts/accordion');
require('../components/dropdown/scripts/dropdown');
require('../components/content-loader/scripts/contentLoader');
require('../components/related-documents/scripts/related-documents');
require('../components/scrollto/scripts/scrollto');
require('../components/media-gallery/scripts/media-gallery');
require('../components/tabs/scripts/tabs');
require('../components/tracking/scripts/tracking');
require('../components/course-table/scripts/cfa-course-table');
require('../components/responsiveImage/scripts/responsive-image');

Snappy.init();



// exclude some huge svg from the sprite
const files = require.context('../assets/svg', false,  /^\.\/(?!thefa|lion|stacked-lions|squad-stats-bg|lion-mask).*\.svg/);
files.keys().forEach(files);



// WEBPACK FOOTER //
// ./scripts/eduhub-from-fa.js